import PollFormState from './PollFormState';
import PollListState from './PollListState';
import PollState from './PollState';

export const states = {
  PollFormState,
  PollListState,
  PollState,
};
